import Availability from "app/models/availability"
import { Action, Types } from "./planningWeekAvailabilities.actions"

export type PlanningWeekAvailabilityState = {
  errors: {}
  loading: boolean
  data: Availability[]
}

const initialState: PlanningWeekAvailabilityState = {
  data: [],
  errors: {},
  loading: false,
}

export default (state = initialState, action: Action): PlanningWeekAvailabilityState => {
  switch (action.type) {
    case Types.GET:
      return {
        ...state,
        loading: true,
      }

    case Types.GET_SUCCESS:
      return {
        ...state,
        data: action.payload.data || [],
        loading: false,
      }

    case Types.GET_FAIL:
      return {
        ...state,
        errors: action.payload.errors,
        loading: false,
      }

    default:
      return state
  }
}
